import { default as app, collapsibleHeaderClickEvent, onWindowResize, resetSelectionColumn, ToggleYellowToGreen, ToggleGreenToYellow, IsUndefinedOrNull } from '@legacy/App';

app.factory('VehicleFactory', ['$http', 'settings', function ($http, settings) {
    return {
        deleteCompartment: function (id, setId) {
            return $http.delete(settings.ApiURL + settings.VehicleURL + "/compartmentsets/compartment/" + setId + "/" + id);
        },
        deleteCompartmentSet: function (id) {
            return $http.delete(settings.ApiURL + settings.VehicleURL + "/compartmentsets/" + id);
        },
        deleteVehicle: function (id, deviceId) {
            return $http.delete(settings.ApiURL + settings.VehicleURL + "/" + id + "/" + deviceId);
        },
        deleteVehicleType: function (id) {
            return $http.delete(settings.ApiURL + settings.VehicleURL + "/vehicletypes/" + id);
        },
        getCompanyList: function () {
            return $http.get(settings.ApiURL + settings.CompanyURL + "/dropdown/1")
        },
        getNonPrintCompanyList: function () {
            return $http.get(settings.ApiURL + settings.CompanyURL + "/nonprintcompanydropdown/1")
        },
        getCompartmentSetList: function () {
            return $http.get(settings.ApiURL + settings.VehicleURL + "/compartmentsets");
        },
        getDeviceTypeList: function () {
            return $http.get(settings.ApiURL + settings.DeviceURL + "/devicetypes")
        },
        getDeviceConfigList: function () {
            return $http.get(settings.ApiURL + settings.DeviceURL + "/deviceconfig")
        },
        getDeviceStateList: function () {
            return $http.get(settings.ApiURL + settings.DeviceURL + "/devicestate")
        },
        getDataAreaList: function () {
            return $http.get(settings.ApiURL + settings.DataAreaURL + "/list/0")
        },
        getFilteredVehicleList: function (filterOptions) {
            return $http.put(settings.ApiURL + settings.VehicleURL + '/filter', filterOptions);
        },
        getNewVehicle: function () {
            return $http.get(settings.ApiURL + settings.VehicleURL + "/newvehicle");
        },
        getSpecialActions: function () {
            return $http.get(settings.ApiURL + settings.VehicleURL + "/specialactions");
        },
        getTimeZones: function () {
            return $http.get(settings.ApiURL + settings.MasterDataURL + "/timezones");
        },
        getTimeZoneValues: function () {
            return $http.get(settings.ApiURL + settings.MasterDataURL + "/timezonesvalues");
        },
        getTrailerStates: function () {
            return $http.get(settings.ApiURL + settings.VehicleURL + "/trailerstate");
        },
        getVehicleDetails: function (id) {
            return $http.get(settings.ApiURL + settings.VehicleURL + "/" + id);
        },
        getVehicleBuildTypes: function () {
            return $http.get(settings.ApiURL + settings.VehicleURL + "/buildtypes");
        },
        getVehicleBoxConfig: function () {
            return $http.get(settings.ApiURL + settings.VehicleURL + "/boxconfig");
        },
        getVehicleClasses: function () {
            return $http.get(settings.ApiURL + settings.VehicleURL + "/vehicleclasses");
        },
        getVehicleTypes: function () {
            return $http.get(settings.ApiURL + settings.VehicleURL + "/vehicletypes/0");
        },
        getVehicleList: function () {
            return $http.get(settings.ApiURL + settings.VehicleURL);
        },
        getLoadPointList: function () {
            return $http.get(settings.ApiURL + settings.LoadPointURL);
        },
        isCompartmentSetDeletable: function (id) {
            return $http.get(settings.ApiURL + settings.VehicleURL + "/compartmentsets/deletable/" + id);
        },
        saveCompartmentSets: function (compartmentSets) {
            return $http.put(settings.ApiURL + settings.VehicleURL + "/compartmentsets", compartmentSets);
        },
        saveSpecialAction: function (vehiclelist, specialaction) {
            var data = { Vehicles: vehiclelist, SpecialActionId: specialaction };
            return $http.put(settings.ApiURL + settings.VehicleURL + "/specialactions", data);
        },
        saveVehicle: function (vehicle) {
            return $http.put(settings.ApiURL + settings.VehicleURL, vehicle);
        },
        saveMultipleVehicles: function (vehicle, vehiclelist) {
            var data = { Vehicles: vehiclelist, Vehicle: vehicle };
            return $http.put(settings.ApiURL + settings.VehicleURL + "/multiplevehicles", data);
        },
        saveVehicleTypes: function (vehicleTypes) {
            return $http.put(settings.ApiURL + settings.VehicleURL + "/vehicletypes", vehicleTypes);
        }
    };
}]);

app.controller('VehicleController', ['$q', '$scope', 'VehicleFactory', 'indexFactory', '$rootScope', 'settings', 'masterFactory', '$uibModal', '$filter',
    function ($q, $scope, VehicleFactory, indexFactory, $rootScope, settings, masterFactory, $uibModal, $filter) {
        $rootScope.pageTitle = "Vehicle";
        $scope.boxConfigList = [];
        $scope.companyList = [];
        $scope.nonprintcompanyList = [];
        $scope.compartmentSetList = [];
        $scope.deviceTypeList = [];
        $scope.deviceConfigList = [];
        $scope.deviceStateList = [];
        $scope.dataAreaList = [];
        $scope.error = "";
        $scope.filterOptions = {
            VehicleType: null, BuildType: null, ClassId: null, CarrierId: null, DeviceTypeId: null,
            DeviceConfigId: null, BoxConfigId: null, UseIgnition: null, DataAreaId: null, TimezoneName: null, State: null,
            VehicleColorHash: null, TankCapacity: null, CompartmentSetId: null, MotorSpeedLimit: null, CountrySpeedLimit: null,
            ResidentialSpeedLimit: null, HomeLatitude: null, HomeLongitude: null, HomeLoadlocationId: null
        };
        $scope.heightContentBoxLeft = document.getElementById('contentBoxLeft').offsetWidth;
        $scope.heightFilterOptions = 80;
        $scope.gridHeight = $scope.heightContentBoxLeft - $scope.heightFilterOptions;
        $scope.isFormVisible = false;        
        $scope.isCompartmentActive = false;        
        $scope.isFilterOptionsOpen = false;
        $scope.isNewEntity = false;        
        $scope.loadPointList = [];
        $scope.modelState = [];
        $scope.multipleSelected = { count: 0, vehiclesList: [] };
        $scope.newVehicle = {};
        $scope.SpecialActions = [];
        $scope.SelectedSpecialAction = {};
        $scope.initialReceiptRange = {};
        $scope.SelectedReceiptRange = {};
        $scope.SelectedReceiptRangeCopy = {};
        $scope.timezoneNameList = [];
        $scope.timezoneValueList = [];
        $scope.trailerStatesList = [];
        $scope.truckTrailerLookup = [
            { IsTruck: 1, Text: 'Truck' },
            { IsTruck: 0, Text: 'Trailer' }
        ];
        $scope.vehicle = {};
        $scope.vehicles = [];
        $scope.vehicleBuildTypes = [];
        $scope.vehicleBuildTypesAll = [];
        $scope.vehicleBuildTypeTruck = [];
        $scope.vehicleBuildTypeTrailer = [];
        $scope.vehicleClasses = [];
        $scope.vehicleTypes = [];
        $scope.vehicleInUse = false;

        // Initialization - this runs on load
        var init = function (pageIndex) {
            masterFactory.verifyAuthentication();


            $('#loadingModal').modal({ backdrop: 'static' });
            $q.all([
                VehicleFactory.getVehicleBuildTypes().success(function (data) {
                    $scope.vehicleBuildTypesAll = data;
                    angular.forEach(data, function (value, key) {
                        if (value.Id < 2)
                            $scope.vehicleBuildTypeTruck.push(value);
                        else if (value.Id > 1)
                            $scope.vehicleBuildTypeTrailer.push(value);
                    });
                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                }),
                VehicleFactory.getVehicleBoxConfig().success(function (data) {
                    $scope.boxConfigList = data;
                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                }),
                VehicleFactory.getVehicleClasses().success(function (data) {
                    $scope.vehicleClasses = data;
                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                }),
                VehicleFactory.getNewVehicle().success(function (data) {
                    $scope.newVehicle = data;
                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                }),
                VehicleFactory.getCompanyList().success(function (data) {
                    $scope.companyList = data;
                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                }),
                VehicleFactory.getNonPrintCompanyList().success(function (data) {
                    $scope.nonprintcompanyList = data;
                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                }),
                VehicleFactory.getCompartmentSetList().success(function (data) {
                    $scope.compartmentSetList = data;
                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                }),
                VehicleFactory.getLoadPointList().success(function (data) {
                    $scope.loadPointList = $filter('orderBy')(data, 'Name1');;
                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                }),
                VehicleFactory.getDeviceTypeList().success(function (data) {
                    $scope.deviceTypeList = data;
                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                }),
                VehicleFactory.getDeviceConfigList().success(function (data) {
                    $scope.deviceConfigList = data;
                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                }),
                VehicleFactory.getDeviceStateList().success(function (data) {
                    $scope.deviceStateList = data;
                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                }),
                VehicleFactory.getDataAreaList().success(function (data) {
                    $scope.dataAreaList = data;
                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                }),
                VehicleFactory.getTimeZones().success(function (data) {
                    $scope.timezoneNameList = data;
                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                }),
                VehicleFactory.getTimeZoneValues().success(function (data) {
                    $scope.timezoneValueList = data;
                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                }),
                VehicleFactory.getTrailerStates().success(function (data) {
                    $scope.trailerStatesList = data;
                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                }),
                VehicleFactory.getVehicleTypes().success(function (data) {
                    $scope.vehicleTypes = data;
                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                }),
                VehicleFactory.getSpecialActions().success(function (data) {
                    $scope.SpecialActions = data;
                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                })
            ]).then(function () {
                VehicleFactory.getVehicleList().success(function (data) {
                    $scope.vehicles = data;
                    $scope.refreshGrid(0, null);
                }).error(function (data, status) {
                    $scope.vehicles = [];
                    masterFactory.setError(status, data, $scope);
                }).finally(function () {
                    $('#loadingModal').modal('hide');
                });
            });

        };

        var getVehicle = function (id) {
            VehicleFactory.getVehicleDetails(id).success(function (data) {
                $scope.vehicle = data;                
                if ($scope.vehicle.deviceDetailsVM != null) {
                    $scope.initialReceiptRange.CompanyId = $scope.vehicle.deviceDetailsVM.RangeVMs[0].CompanyId;
                    $scope.SelectedReceiptRange = $scope.vehicle.deviceDetailsVM.RangeVMs[0];
                    $scope.SelectedReceiptRangeCopy = angular.copy($scope.SelectedReceiptRange);
                }
                else {
                    $scope.initialReceiptRange.CompanyId = null;
                    $scope.SelectedReceiptRange = {};
                    $scope.SelectedReceiptRangeCopy = {};
                }
                if ($scope.vehicle.BuildType != null) {                    
                  if ($scope.vehicle.BuildType < 2)
                      $scope.TruckTrailerChange(true);
                  else $scope.TruckTrailerChange(false);
                }
                else { // if null then it's a truck                   
                    $scope.TruckTrailerChange(true);
                }

                if ($scope.vehicle.CompartmentSet != null && $scope.vehicle.Tank != null) {
                    $scope.vehicle.Tank = null;
                }
            }).error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            });
        };

        init(0);

        $scope.TruckTrailerChange = function (boolvalue) {
            if (boolvalue) {                
                $scope.isTruck = "true";
                $scope.vehicle.IsTrailerGpsBox = false;
                $scope.vehicleBuildTypes = $scope.vehicleBuildTypeTruck;                
            }
            else if (!boolvalue) {                
                $scope.isTruck = "false";
                $scope.vehicleBuildTypes = $scope.vehicleBuildTypeTrailer; 
                if ($scope.vehicle.BuildType == null || $scope.vehicle.BuildType < 2) $scope.vehicle.BuildType = 2;
		        if ($scope.vehicle.deviceDetailsVM.Id > 0) $scope.vehicle.IsTrailerGpsBox = true;
            }
        };

        $scope.refreshGrid = function (PageIndex, ids) {
            $('#VehicleGrid').dxDataGrid({
                dataSource: {
                    store: {
                        data: $scope.vehicles,
                        type: 'array',
                        key: 'Id'
                    }
                },
                columns: [
                    {
                        caption: 'Icon', dataField: 'IsTruck', alignment: 'center', width: '100px',
                        cellTemplate: function (cellElement, cellInfo) {
                            if (cellInfo.data.IsTruck == true) {
                                $("<span />")
                                    .attr("class", "icon icon-fulltruck")
                                    .attr("style", "color:" + cellInfo.data.ColorHash + ";font-size:2em;")
                                    .appendTo(cellElement);
                            }
                            else {
                                $("<span />")
                                    .attr("class", "icon-trailer")
                                    .attr("style", "font-size:2em;")
                                    .appendTo(cellElement);
                            }
                        },
                        lookup: { dataSource: $scope.truckTrailerLookup, valueExpr: 'IsTruck', displayExpr: 'Text' }
                    },
                    { caption: 'Vehicle Id', dataField: 'Id', cssClass: 'Id', dataType: 'number', visible: false },
                    {
                        caption: 'Device Id - Name', dataField: 'DeviceId', dataType: 'string', alignment: 'center',
                        cellTemplate: function (container, options) {
                            var devicedetails = "";
                            if (options.data.DeviceId != 0) devicedetails = devicedetails + options.data.DeviceId + " - ";
                            if (options.data.DeviceName != null) devicedetails = devicedetails + options.data.DeviceName;
                            $('<span />').text(devicedetails).append("</br>").appendTo(container);
                        },
                        calculateCellValue: function (data) {
                            return data.DeviceId + " - " + data.DeviceName;
                        },
                        calculateFilterExpression: function (filterValue, selectedFilterOperation) {
                            return [this.calculateCellValue, selectedFilterOperation || 'contains', filterValue];
                        }
                    },
                    { caption: 'Vehicle No', dataField: 'VehicleNumber', cssClass: 'VehicleNumber', dataType: 'string', alignment: 'center' },
                    { caption: 'License Plate', dataField: 'LicensePlate', cssClass: 'LicensePlate', dataType: 'string', alignment: 'center', width: 150 }
                ],
                contentReadyAction: grdReadyAction,
                filterRow: { visible: true },
                groupPanel: { visible: false, },
                height: $scope.gridHeight,
                //height: "100%",
                noDataText: "No Vehicles Found",
                pager: { showPageSizeSelector: true, allowedPageSizes: [10, 20, 30] },
                paging: { pageSize: $scope.pageSize, pageIndex: PageIndex },
                rowAlternationEnabled: false,
                scrolling: { mode: 'standard' },
                selection: { mode: 'multiple' },
                showBorders: true,
                showColumnLines: true,
                showRowLines: false,
                selectionChanged: function (selectedRowsInfo) {
                    $scope.multipleSelected.vehiclesList = [];
                    if (selectedRowsInfo.selectedRowsData.length > 1) {
                        // Display empty form with Vehicle specific data disabled.
                        $scope.vehicle = angular.copy($scope.newVehicle);
                        // stored selected vehicles in a array multipleSelected.vehiclesList
                        for (var i = 0; i < selectedRowsInfo.selectedRowsData.length; i++) {
                            $scope.multipleSelected.vehiclesList.push(selectedRowsInfo.selectedRowsData[i].Id);
                        }
                        $scope.multipleSelected.count = selectedRowsInfo.selectedRowsData.length;
                        $scope.isDeleteVisible = false;
                    }
                    else if (selectedRowsInfo.selectedRowsData.length == 1) {
                        $scope.multipleSelected.count = 1;
                        getVehicle(selectedRowsInfo.selectedRowsData[0].Id);
                        $scope.isDeleteVisible = true;
                    }
                    else {
                        $scope.multipleSelected.count = 0;
                        $scope.vehicle = angular.copy($scope.newVehicle);
                        $scope.isDeleteVisible = false;
                    }
                    $scope.isNewEntity = false;
                    $rootScope.pageTitle = "Vehicle";
                    $scope.isFormVisible = true;
                    ToggleYellowToGreen();
                }
            });
            if (ids != null && ids.length > 0) {
                var dataGrid = $('#VehicleGrid').dxDataGrid('instance');
                (dataGrid as unknown as FacnmDx).selectRows(ids);
            }
        };

        // Button click functions and submit form function
        $scope.addNewEntity = function () {
            $rootScope.pageTitle = "New Vehicle";
            $scope.isFormVisible = true;
            $scope.isDeleteVisible = false;
            $scope.isNewEntity = true;
            $scope.SetIDManually = false;
            $scope.vehicle = angular.copy($scope.newVehicle);
            $scope.initialReceiptRange.CompanyId = null;
            $scope.SelectedReceiptRange = null;
            $scope.TruckTrailerChange(true);
            ToggleGreenToYellow();
        };

        $scope.confirmDeleteEntity = function () {
            $scope.vehicleInUse = false;
            if(($scope.isTruck == 'true' && $scope.vehicle.deviceDetailsVM.State==1) || ($scope.isTruck == 'false' && $scope.vehicle.State == 1)){
                $scope.vehicleInUse = true;    
            }            
            $('#DeleteModal').modal({ backdrop: 'static' });
        };

        $scope.deleteEntity = function (value) {
            if (value == 0) {
                $('#DeleteModal').modal('hide');
            }
            else if (value == 1) {
                var vehicleId = $scope.vehicle.Id;
                var deviceId = $scope.vehicle.deviceDetailsVM != null ? $scope.vehicle.deviceDetailsVM.Id : null;
                VehicleFactory.deleteVehicle(vehicleId, deviceId).success(function (data) {
                    VehicleFactory.getVehicleList().success(function (data) {
                        var dataGrid = $('#VehicleGrid').dxDataGrid('instance');
                        $scope.pageSize = dataGrid.pageSize();
                        var pageindex = dataGrid.pageIndex();
                        $scope.vehicles = data;
                        $scope.cancelForm();
                        $scope.refreshGrid(pageindex);
                    }).error(function (data, status) {
                        masterFactory.setError(status, data, $scope);
                    });
                    $scope.notify.add({ type: 'success', title: 'Success!', body: 'Deleted Vehicle successfully' });
                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                }).finally(function () {
                    $('#DeleteModal').modal('hide');
                });
            }
        };

        $scope.filterVehicles = function () {
            $scope.closeAlert();
            $scope.closeModelStateErrors();
            $('#loadingModal').modal({ backdrop: 'static' });
            VehicleFactory.getFilteredVehicleList($scope.filterOptions).success(function (data) {
                var dataGrid = $('#VehicleGrid').dxDataGrid('instance');
                $scope.pageSize = dataGrid.pageSize();
                var pageindex = dataGrid.pageIndex();
                $scope.vehicles = data;
                $scope.refreshGrid(pageindex, null);
                $scope.notify.add({ type: 'success', title: 'Success!', body: 'Filter applied successfully' });
            }).error(function (data, status) {
                $scope.vehicles = [];
                masterFactory.setError(status, data, $scope);
            }).finally(function () {
                $('#loadingModal').modal('hide');
            });
        };

        $scope.resetfilterOptions = function () {
            $scope.closeAlert();
            $scope.closeModelStateErrors();
            $('#loadingModal').modal({ backdrop: 'static' });
            $scope.filterOptions = {
                VehicleType: null, BuildType: null, ClassId: null, CarrierId: null, DeviceTypeId: null,
                DeviceConfigId: null, BoxConfigId: null, UseIgnition: null, DataAreaId: null, TimezoneName: null, State: null,
                VehicleColorHash: null, TankCapacity: null, CompartmentSetId: null, MotorSpeedLimit: null, CountrySpeedLimit: null,
                ResidentialSpeedLimit: null, HomeLatitude: null, HomeLongitude: null, HomeLoadlocationId: null
            };
            VehicleFactory.getVehicleList().success(function (data) {
                $scope.vehicles = data;
                $scope.refreshGrid(0, null);
            }).error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            });
            $('#loadingModal').modal('hide');
            $scope.cancelForm();
            $scope.notify.add({ type: 'success', title: 'Success!', body: 'Filter options reset successfully' });
        };

        $scope.reset = function (type) {
            if (type == 'update') { // get db vehicle and set to scope.vehicle
                getVehicle($scope.vehicle.Id);
            }
            else {
                angular.copy($scope.newVehicle, $scope.vehicle);
            }
            $scope.vehicleForm.$setPristine();
            $scope.vehicleForm.$submitted = false;
            $scope.closeModelStateErrors();
            $scope.closeAlert();
            $scope.notify.add({ type: 'success', title: 'Success!', body: 'Vehicle details were reset' });
        };

        $scope.cancelForm = function () {
            var dataGrid = $('#VehicleGrid').dxDataGrid('instance');
            dataGrid.clearSelection();
            $scope.isFormVisible = false;
            $scope.vehicleForm.$submitted = false;
            $scope.closeModelStateErrors();
            $scope.closeAlert();
        };

        $scope.submitForm = function () {

            if ($scope.isTruck == 'true') {
                
                $scope.vehicleForm.RangeStart.$setValidity('range', true);
                $scope.error = '';

                if ($scope.vehicle.deviceDetailsVM.RangeVMs) {
                    let currentReceiptNumbers = $scope.vehicle.deviceDetailsVM.RangeVMs.find(function (r) { return r.CompanyId == $scope.vehicle.deviceDetailsVM.CompanyId })

                    if (currentReceiptNumbers) {

                        let currentReceiptStart = currentReceiptNumbers.RangeStart;

                        if (!(currentReceiptStart >= currentReceiptNumbers.Range1From && currentReceiptStart <= currentReceiptNumbers.Range1To
                            || currentReceiptStart >= currentReceiptNumbers.Range2From && currentReceiptStart <= currentReceiptNumbers.Range2To)) {

                            $scope.vehicleForm.RangeStart.$setValidity('range', false);
                            $scope.error = "Receipt Start must be between one of the Ranges bounds.";
                        }
                    }
                }
            }

            if ($scope.vehicleForm.$valid) {                

                if ($scope.isTruck == 'true' && !angular.equals($scope.SelectedReceiptRange, $scope.SelectedReceiptRangeCopy)&& $scope.vehicle.Id > 0) {

                    $('#ReceiptRangeChangingModal').modal({ backdrop: 'static' });
                }

                else {
                    $scope.saveVehicle();
                    $scope.vehicleForm.$submitted = false;
                }
            }
            else {
                $scope.vehicleForm.$submitted = true;
            }
        };


        $scope.receiptRangeChangingModal_onClick = function (sendReceiptRangeChange: boolean) {

            $('#ReceiptRangeChangingModal').modal('hide');

            if (sendReceiptRangeChange) {

                let vehicleList = $scope.multipleSelected.vehiclesList.length > 0 ? $scope.multipleSelected.vehiclesList : [$scope.vehicle.Id];

                $('#loadingModal').modal({ backdrop: 'static' });
                VehicleFactory.saveSpecialAction(vehicleList, 1).success(function () {

                    indexFactory.exportVehicles(vehicleList).success(function () {

                        $scope.saveVehicle();
                        $scope.vehicleForm.$submitted = false;
                        $scope.notify.add({ type: 'success', title: 'Success!', body: 'Special Action implemented successfully' });
                    }).error(function (data, status) {
                        $scope.notify.add({ type: 'danger', title: 'Error!', body: 'Vehicle Export failed' });
                        $scope.notify.add({ type: 'danger', title: 'Error!', body: 'Vehicle not updated' });
                        masterFactory.setError(status, data, $scope);
                        angular.element(".contentBoxRight")[0].scrollTop = 0;
                    });

                }).error(function (data, status) {
                    $scope.notify.add({ type: 'danger', title: 'Error!', body: 'Special Action not implemented' });
                    $scope.notify.add({ type: 'danger', title: 'Error!', body: 'Vehicle not updated' });
                    masterFactory.setError(status, data, $scope);
                    angular.element(".contentBoxRight")[0].scrollTop = 0;
                }).finally(function () {
                    $('#loadingModal').modal('hide');
                });
            }
            else {
                $scope.saveVehicle();
                $scope.vehicleForm.$submitted = false;
            }
        };


        $scope.SubmitSpecialAction = function () {
            $('#loadingModal').modal({ backdrop: 'static' });

            let vehicleList = $scope.multipleSelected.vehiclesList.length > 0 ? $scope.multipleSelected.vehiclesList : [$scope.vehicle.Id];

            VehicleFactory.saveSpecialAction(vehicleList, $scope.SelectedSpecialAction).success(function () {
                $scope.notify.add({ type: 'success', title: 'Success!', body: 'Special Action implemented successfully' });
            }).error(function (data, status) {
                $scope.notify.add({ type: 'danger', title: 'Error!', body: 'Special Action not implemented' });
                masterFactory.setError(status, data, $scope);
            }).finally(function () {
                $('#loadingModal').modal('hide');
            });
        };

        $scope.saveVehicle = function () {
            $('#loadingModal').modal({ backdrop: 'static' });
            var pageindex, id;
            $scope.closeModelStateErrors();
            if ($scope.multipleSelected.vehiclesList.length > 1) { // save multiple vehicles
                VehicleFactory.saveMultipleVehicles($scope.vehicle, $scope.multipleSelected.vehiclesList).success(function (data) {

                    VehicleFactory.getVehicleList().success(function (data) {
                        var dataGrid = $('#VehicleGrid').dxDataGrid('instance');
                        $scope.pageSize = dataGrid.pageSize();
                        pageindex = dataGrid.pageIndex();
                        $scope.vehicles = data;
                        $scope.refreshGrid(pageindex, $scope.multipleSelected.vehiclesList);
                    }).error(function (data, status) {
                        masterFactory.setError(status, data, $scope);
                    }).finally(function () {
                        $scope.notify.add({ type: 'success', title: 'Success!', body: 'Updated Vehicles successfully' });
                    });

                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                }).finally(function () {
                    $('#loadingModal').modal('hide');
                });
            }
            else if ($scope.multipleSelected.count == 1 || $scope.isNewEntity) { // save single vehicle
                VehicleFactory.saveVehicle($scope.vehicle).success(function (data) {
                    if (data.ConflictingResult.length > 0) {
                        $scope.viewConflictingReceiptNumbersModal(data);
                    }
                    else {
                        VehicleFactory.getVehicleList().success(function (data) {
                            var dataGrid = $('#VehicleGrid').dxDataGrid('instance');
                            $scope.pageSize = dataGrid.pageSize();
                            pageindex = dataGrid.pageIndex();
                            $scope.vehicles = data;
                            if ($scope.vehicle.Id > 0) {
                                $scope.refreshGrid(pageindex, [$scope.vehicle.Id]);
                            }
                            if ($scope.vehicle.Id <= 0) {
                                $scope.cancelForm();
                                $scope.refreshGrid(pageindex, null);
                            }
                        }).error(function (data, status) {
                            masterFactory.setError(status, data, $scope);
                        }).finally(function () {
                            if ($scope.vehicle.Id > 0) {
                                $scope.notify.add({ type: 'success', title: 'Success!', body: 'Updated Vehicle successfully' });
                            }
                            else {
                                $scope.notify.add({ type: 'success', title: 'Success!', body: 'Created Vehicle successfully' });
                            }
                        });
                    }
                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                }).finally(function () {
                    $('#loadingModal').modal('hide');
                });
            }
            else {
                $scope.notify.add({ type: 'info', title: 'Info!', body: 'No Vehicle selected' });
                $('#loadingModal').modal('hide');
            }

        };

        $scope.viewVehicleTypeModal = function () {
            var modalInstance = $uibModal.open({
                templateUrl: 'app-legacy/Entities/templates/vehicleTypeModal.html',
                controller: 'VehicleTypeModalController',
                controllerAs: 'modalVm',
                size: 'md',
                scope: $scope
            });

            modalInstance.result.then(function (vehicletypelist) {
                VehicleFactory.getVehicleTypes().success(function (data) {
                    $scope.vehicleTypes = data;
                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                });
                $scope.notify.add({ type: 'success', title: 'Success!', body: 'Saved Vehicle Types successfully' });
            }, function () {

            });
        };

        $scope.viewCompartmentsModal = function () {
            var modalInstance = $uibModal.open({
                templateUrl: 'app-legacy/Entities/templates/compartmentsModal.html',
                controller: 'CompartmentsModalController',
                controllerAs: 'modalVm',
                size: 'lg',
                scope: $scope,
                windowTemplateUrl: 'app-legacy/Entities/templates/modal-scrollable-content.html'
            });

            modalInstance.result.then(function (message) {
                if (message == 'ok') {
                    VehicleFactory.getCompartmentSetList().success(function (data) {
                        $scope.compartmentSetList = data;
                    }).error(function (data, status) {
                        masterFactory.setError(status, data, $scope);
                    });
                    $scope.notify.add({ type: 'success', title: 'Success!', body: 'Saved Compartment Sets successfully' });
                }

            }, function () {

            });
        };

        $scope.viewConflictingReceiptNumbersModal = function (response) {
            var modalInstance = $uibModal.open({
                templateUrl: 'app-legacy/Entities/templates/ConflictingReceiptNumbersModal.html',
                controller: 'ConflictingReceiptNumbersModalController',
                controllerAs: 'modalVm',
                size: 'md',
                scope: $scope,
                resolve: {
                    DeviceResult: function () {
                        return response.ConflictingResult;
                    }
                }
            });

            modalInstance.result.then(function (ignoreConflictingReceiptNumbers) {
                if (ignoreConflictingReceiptNumbers == 1) {
                    $scope.vehicle.deviceDetailsVM.IgnoreConflictingReceiptNumbers = true;
                    $scope.saveVehicle();
                }
                else $scope.vehicle.deviceDetailsVM.IgnoreConflictingReceiptNumbers = false;
            }, function () {

            });
        };

        $scope.UpdateReceiptRange = function (companyId) {
            if ($scope.vehicle.deviceDetailsVM != null) {
                if (companyId != null) {
                    var result = $scope.vehicle.deviceDetailsVM.RangeVMs.filter(function (rvm) {
                        return rvm.CompanyId == companyId;
                    });
                    $scope.SelectedReceiptRange = result[0];
                    $scope.SelectedReceiptRangeCopy = angular.copy($scope.SelectedReceiptRange);
                }
                else if ($scope.initialReceiptRange != null) {
                    var result = $scope.vehicle.deviceDetailsVM.RangeVMs.filter(function (rvm) {
                        return rvm.CompanyId == $scope.initialReceiptRange.CompanyId;
                    });
                    $scope.SelectedReceiptRange = result[0];
                    $scope.SelectedReceiptRangeCopy = angular.copy($scope.SelectedReceiptRange);
                }
            }
            else {
                $scope.SelectedReceiptRange = null;
                $scope.SelectedReceiptRangeCopy = null;
            }
        };

        // Helping functions and events
        $(window).resize(function () {
            //onWindowResize('#VehicleGrid', settings.GridMarginHeight);
        });

        function grdReadyAction(e) {
            //onWindowResize('#VehicleGrid', settings.GridMarginHeight);
        };

        collapsibleHeaderClickEvent($scope);

        $scope.closeAlert = function () {
            $scope.error = null;
        };

        $scope.closeModelStateErrors = function () {
            $scope.modelState = [];
        };

        $scope.clickHalfDiv = function (control) {
            masterFactory.setFocus(control);
        };

    }]);

app.controller('ConflictingReceiptNumbersModalController', ['$scope', '$uibModalInstance', '$uibModal', 'DeviceResult',
    function ($scope, $uibModalInstance, $uibModal, DeviceResult) {
        var modalVm = this;

        modalVm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        modalVm.IgnoreConflict = function (boolvalue) {
            $uibModalInstance.close(boolvalue);
        };

        function init() {
            modalVm.ConflictingDevices = angular.copy(DeviceResult);
        };

        init();
    }]);

app.controller('VehicleTypeModalController', ['$scope', 'VehicleFactory', '$uibModalInstance', '$uibModal', 'masterFactory',
    function ($scope, VehicleFactory, $uibModalInstance, $uibModal, masterFactory) {
        var modalVm = this;

        init();

        modalVm.addNewVehicleType = function () {
            var newidcount = -1;
            for (var i = 0; i <= modalVm.VehicleTypesList.length - 1; i++) {
                if (modalVm.VehicleTypesList[i].Id <= 0) {
                    newidcount--;
                }
            }
            modalVm.NewVehicleType = { Id: newidcount, Name: "", Color: "", ColorHash: "" };
            modalVm.VehicleTypesList.push(modalVm.NewVehicleType);
        };

        modalVm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        modalVm.closeAlert = function () {
            modalVm.error = "";
        };

        modalVm.closeModelStateErrors = function () {
            modalVm.modelState = [];
        };

        modalVm.deleteVehicleType = function (item, index) {
            if (item.Id <= 0) {
                modalVm.VehicleTypesList.splice(index, 1);
            }
            else if (item.Id > 0) {
                // already existing vehicle types, have to delete on the server.
                VehicleFactory.deleteVehicleType(item.Id).success(function (data) {
                    modalVm.VehicleTypesList.splice(index, 1);
                }).error(function (data, status) {
                    masterFactory.setError(status, data, modalVm);
                });
            }
        };

        modalVm.save = function () {
            if ($scope.vehicleTypeForm.$valid) {
                $scope.vehicleTypeForm.$submitted = false;
                VehicleFactory.saveVehicleTypes(modalVm.VehicleTypesList).success(function (data) {
                    $uibModalInstance.close(modalVm.VehicleTypesList);
                }).error(function (data, status) {
                    masterFactory.setError(status, data, modalVm);
                });
            }
        };

        function init() {
            modalVm.error = "";
            modalVm.modelState = [];
            VehicleFactory.getVehicleTypes().success(function (data) {
                modalVm.VehicleTypesList = data;
            }).error(function (data, status) {
                masterFactory.setError(status, data, modalVm);
            });
        };
    }]);

app.controller('CompartmentsModalController', ['$scope', 'VehicleFactory', '$uibModalInstance', '$uibModal', 'masterFactory',
    function ($scope, VehicleFactory, $uibModalInstance, $uibModal, masterFactory) {
        var modalVm = this;

        modalVm.addNewCompartmentSet = function () {
            var newidcount = -1;
            for (var i = 0; i <= modalVm.CompartmentSetList.length - 1; i++) {
                if (modalVm.CompartmentSetList[i].Id <= 0) newidcount--;
            }
            modalVm.NewCompartmentSet = { Id: newidcount, Name: "", Compartments: [] };
            modalVm.CompartmentSetList.push(modalVm.NewCompartmentSet);
        };

        modalVm.addNewCompartment = function () {
            var newidcount = -1;
            for (var i = 0; i <= modalVm.CompartmentList.length - 1; i++) {
                if (modalVm.CompartmentList[i].Id <= 0) newidcount--;
            }
            modalVm.NewCompartment = { Id: newidcount, Capacity: "" };
            modalVm.CompartmentList.push(modalVm.NewCompartment);
        };

        modalVm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        modalVm.closeAlert = function () {
            modalVm.error = "";
        };

        modalVm.closeModelStateErrors = function () {
            modalVm.modelState = [];
        };

        modalVm.deleteCompartmentSet = function (item, index) {
            if (item.Id <= 0) {
                modalVm.CompartmentSetList.splice(index, 1);
                modalVm.CompartmentList = [];
            }
            else if (item.Id > 0) {
                VehicleFactory.isCompartmentSetDeletable(item.Id).success(function (data) {
                    if (data == true) { // if deletable then make a delete call
                        VehicleFactory.deleteCompartmentSet(item.Id).success(function (data) {
                            modalVm.CompartmentSetList.splice(index, 1);
                            modalVm.CompartmentList = [];
                        }).error(function (data, status) {
                            masterFactory.setError(status, data, modalVm);
                        });
                    }
                    else { // else if not deletable then ask for confirmation.
                        modalVm.CompartmentSetToDelete = { item: item, index: index };
                        modalVm.OpenConfirmation();
                    }
                }).error(function (data, status) {
                    masterFactory.setError(status, data, modalVm);
                });
            }
        };

        modalVm.DeleteCS = function (boolvalue) {
            if (boolvalue == 1) {
                // compartment set to delete from server;
                VehicleFactory.deleteCompartmentSet(modalVm.CompartmentSetToDelete.item.Id).success(function (data) {
                    modalVm.CompartmentSetList.splice(modalVm.CompartmentSetToDelete.index, 1);
                    modalVm.CompartmentList = [];
                }).error(function (data, status) {
                    masterFactory.setError(status, data, modalVm);
                });
            }
        };

        modalVm.deleteCompartment = function (item, index) {
            if (item.Id <= 0) {
                modalVm.CompartmentList.splice(index, 1);
            }
            else if (item.Id > 0) {
                // code to delete from server.
                VehicleFactory.deleteCompartment(item.Id, item.SetId).success(function (data) {
                    modalVm.CompartmentList.splice(index, 1);
                }).error(function (data, status) {
                    masterFactory.setError(status, data, modalVm);
                });
            }
        };

        modalVm.OpenConfirmation = function () {
            var confirmModalInstance = $uibModal.open({
                templateUrl: 'app-legacy/Entities/templates/DeleteConfirmationModal.html',
                controller: 'DeleteCompartmentsConfirmationModalController',
                controllerAs: 'modalVm',
                size: 'md'
            });

            confirmModalInstance.result.then(function (message) {
                if (message == '1') modalVm.DeleteCS(1);
                else if (message == '0') modalVm.DeleteCS(0);
            }, function () {

            });
        };

        modalVm.save = function () {
            if ($scope.compartmentSetForm.$valid) {
                $scope.compartmentSetForm.$submitted = false;
                VehicleFactory.saveCompartmentSets(modalVm.CompartmentSetList).success(function (data) {
                    $uibModalInstance.close('ok');
                }).error(function (data, status) {
                    masterFactory.setError(status, data, modalVm);
                });
            }

        };

        modalVm.selectedCompartmentSet = function (index) {
            modalVm.selectedCompartmentSetId = index;
            modalVm.CompartmentList = modalVm.CompartmentSetList[index].Compartments;
            modalVm.CompartmentListCopy = angular.copy(modalVm.CompartmentSetList[index].Compartments);
        };

        function init() {
            modalVm.error = "";
            modalVm.modelState = [];
            VehicleFactory.getCompartmentSetList().success(function (data) {
                modalVm.CompartmentSetList = data;
                modalVm.selectedCompartmentSet(0);
            }).error(function (data, status) {
                masterFactory.setError(status, data, modalVm);
            });
            modalVm.CompartmentList = [];
            modalVm.CompartmentListCopy = [];
            modalVm.CompartmentSetToDelete = { item: null, index: null };
        };

        init();
    }]);

app.controller('DeleteCompartmentsConfirmationModalController', ['$scope', '$uibModalInstance', '$uibModal',
    function ($scope, $uibModalInstance, $uibModal) {
        var modalVm = this;

        modalVm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        modalVm.DeleteCS = function (boolvalue) {
            if (boolvalue == 1)
                $uibModalInstance.close('1');
            else if (boolvalue == 0) $uibModalInstance.close('0');
        };
    }]);
